import * as React from "react";
import { VerifyContact } from "aws-amplify-react";
import {
  FormSection,
  SectionHeader,
  SectionBody,
  SectionFooter,
  Button,
  Link,
  SectionFooterPrimaryContent,
  SectionFooterSecondaryContent
} from "aws-amplify-react/dist/Amplify-UI/Amplify-UI-Components-React";
import { auth } from "aws-amplify-react/dist/Amplify-UI/data-test-attributes";
import { I18n } from "aws-amplify";

export default class CustomVerifyContact extends VerifyContact {
  showComponent(theme) {
    const { authData } = this.props;
    return (
      <FormSection theme={theme} data-test={auth.verifyContact.section}>
        <SectionHeader theme={theme} data-test={auth.verifyContact.headerSection}>
          {I18n.get("Account recovery requires verified contact information")}
        </SectionHeader>
        <SectionBody theme={theme} data-test={auth.verifyContact.bodySection}>
          {this.state.verifyAttr ? this.submitView() : this.verifyView()}
        </SectionBody>
        <SectionFooter theme={theme}>
          <SectionFooterPrimaryContent theme={theme}>
            {this.state.verifyAttr ? (
              <Button theme={theme} onClick={this.submit} data-test={auth.verifyContact.submitButton}>
                {I18n.get("Submit")}
              </Button>
            ) : (
              <Button theme={theme} onClick={this.verify} data-test={auth.verifyContact.verifyButton}>
                {I18n.get("Verify")}
              </Button>
            )}
          </SectionFooterPrimaryContent>
          <SectionFooterSecondaryContent theme={theme}>
            <Link theme={theme} onClick={() => this.changeState("signedIn", authData)} data-test={auth.verifyContact.skipLink}>
              {I18n.get("Skip")}
            </Link>
          </SectionFooterSecondaryContent>
        </SectionFooter>
      </FormSection>
    );
  }
}
